<template>
  <div class="flex flex-col space-y-2">
    <h3 class="">Special Pasting Formatting</h3>
    <p class="text-truegray-500">
      These special paste formatting options allow you to manipulate the way you
      paste content into the editor. To use them, you need to click the option
      you would like to use, e.g., "Paste from email", then paste your content
      into the editor.
    </p>
    <p class="text-truegray-500 pb-4 italic">
      Note: This feature is only usable at the start of your post.
    </p>

    <h3 class="text-sm">Paste from email</h3>
    <p class="text-truegray-500 pb-4">
      This option simplifies copying and pasting content from emails to our
      platform by automatically removing tables. It keeps all other formatting
      like headings, links, bulleted lists. You don't need to understand any
      technical terms. Just use the function when copying from an email, and the
      application does the rest.
    </p>

    <h3 class="text-sm">Paste without formatting</h3>
    <p class="text-truegray-500">
      This option removes all formatting from your copied content, and pastes it
      as plain text. This is useful if you are copying content from a website,
      and want to remove all the formatting. This will remove everything from
      headings to links to bold/italic.
    </p>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'EditorLinkModal',

  setup() {
    return {}
  },
})
</script>
